export enum ChildsMenuEnum {
    HOME = 900,
    RESERVA_VEHICULOS_CORTESIA = 1001,
    GESTION_VEHICULOS = 1002,
    GESTION_TERCEROS = 1003,
    GESTION_VEHICULOSVC = 1004,
    MANT_GENERAL = 1100,
    INF_GENERAL = 1300,
    PEDIDOS_PIEZAS = 2002,
    ENTRADAS_ALMACEN = 2003,
    VENTAS_MOSTRADOR = 2004,
    HOME_ALMACEN = 2000,
    GESTION_ARTICULOS = 2001,
    CORRECCION_STOCK = 2005,
    PRESUPUESTOS_VM = 2006,
    BAJA_MASIVA_PIEZAS = 2007,
    INVENTARIO = 2008,
    MANT_ALMACEN = 2100,
    INF_ALMACEN = 2300,
    HOME_TALLER = 3000,
    AGENDA_CITAS = 3001,
    RECEPCION_VEHICULO = 3002,
    GESTION_OR = 3003,
    PROCESOS_GARANTIA = 3004,
    PRESUPUESTOS_TALLER = 3005,
    BAREMOS_TALLER = 3006,
    GARANTIA_SAGAI = 3007,
    MANT_TALLER = 3100,
    INF_TALLER = 3300,
    HOME_FACTURAS = 4000,
    FACTURACION_OPERACIONES = 4001,
    FACTURACION_MANUAL = 4002,
    RECIBOS_Y_VENCIMIENTOS = 4003,
    LIBRETA = 4004,
    FACTURACION_AGRUPADA = 4005,
    FACTURAS_RECIBIDAS = 4006,
    FACTURACION_MASIVA_OR = 4007,
    FACT_REMESAS = 4008,
    FACTURAE = 4009,
    FACT_GESTIONCOBROS = 4010,
    TICKETBAI = 4011,
    AUTOFACTURA = 4012,
    BATUZ = 4013,
    FACT_GESTIONPAGOS = 4071,
    MANT_FAC = 4200,
    INF_FACTURAS = 4300,
    INTERFACES_MARCA = 5001,
    INTERFACES_AUTOMATICAS = 5002,
    INTERFACES_EXTERNAS = 5003,
    INTERFACES_ENVIOS_EXTERNOS = 5004,
    INTERFACE_SII = 5005,
    DDC_ACKNOWLEDGE = 5007,
    HOME_CONTABILIDAD = 6000,
    CONTABILIDAD_EXPORTACION = 6001,
    CONTABILIDAD_CONFIGURACION = 6002,
    HOME_VO = 7000,
    VEHICULOS_VO = 7001,
    CLIENTES_VO = 7002,
    RECEPCION_VO = 7003,
    GESTION_VO = 7004,
    VENTA_VO = 7005,
    MANT_VO = 7100,
    INF_VO = 7300,
    MARKETING = 8001,
    GESTION_EMPLEADOS = 9001,
    FICHAJES_EMPLEADOS = 9002,
    GEN_FICHAJESEMP_AUTOMATIC = 9003,
    MANT_PRODUCTIVIDAD = 9100,
    INF_PRODUCTIVIDAD = 9300
}
